<app-uni-page [parent]="this" pageTitle="Receive Purchase Order" [bodyTemplate]="bodyTemplate" [footerTemplate]="footerTemplate">
</app-uni-page>

<ng-template #bodyTemplate>
  <div class="flex h-full flex-col">
    <!-- PO Header Summary -->
    <div *ngIf="poHeaders?.length > 0" class="qb-detail-card qb-primary-tint mx-4 mb-4 mt-2 w-[900px] shrink-0 p-4">
      <div *ngIf="isAccountOwnedPo" class="mb-3 flex items-center gap-2 rounded border border-yellow-500 bg-yellow-100 px-3 py-2 text-sm font-semibold text-yellow-900">
        <i class="pi pi-briefcase"></i>
        <span>Account-Owned Inventory PO — units on receipt become inventory of {{ accountOwnedAccountName || 'the account' }}.</span>
      </div>
      <div class="flex justify-between">
        <div class="qb-stacked-field">
          <div class="label">Purchase Order</div>
          <div class="value text-lg font-semibold">{{ poHeaders[0].id }}</div>
        </div>
        <div class="qb-stacked-field">
          <div class="label">Manufacturer</div>
          <div class="value font-semibold">{{ poHeaders[0].manufacturer?.name }}</div>
        </div>
        <div class="qb-stacked-field">
          <div class="label">Status</div>
          <div class="value font-semibold">{{ poHeaders[0].poStatus?.name }}</div>
        </div>
        <div class="qb-stacked-field">
          <div class="label">P/O Date</div>
          <div class="value font-semibold">{{ poHeaders[0].poDate | date: 'shortDate' }}</div>
        </div>
        <div class="qb-stacked-field text-right">
          <div class="label">Remaining Qty</div>
          <div class="value text-lg font-semibold">{{ pohRemainingQty }}</div>
        </div>
      </div>
    </div>

    <!-- Details Grid -->
    <div class="min-h-0 flex-1 px-4">
      <app-ag-grid gridId="purchaseOrderDetailsGrid" [gridOptions]="podGridOptions" [rowData]="poDetails" class="h-full"></app-ag-grid>
    </div>

    <!-- Pod Summaries (optional) -->
    <div *ngIf="shouldShowPodSummaries" class="shrink-0 px-4 pb-2">
      <div class="w-1/4">
        <app-ag-grid [gridOptions]="podsGridOptions" [rowData]="podSummaries" [hasFooter]="false" class="h-36"></app-ag-grid>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #footerTemplate>
  <div class="left-buttons mt-2">
    <button pButton type="button" class="p-button-raised" icon="pi pi-arrow-left" (click)="goBack()">
      <span>Go Back</span>
    </button>
    <button id="applyAllbutton" [disabled]="!canApplyAny()" pButton type="button" class="p-button-raised" (click)="applyAll()">
      <span>Apply All</span>
    </button>
    <button [disabled]="!canPrintBarcodes()" pButton type="button" class="p-button-raised" (click)="printBarcodes()">
      <span>Print Selected Barcodes</span>
    </button>
    <button pButton type="button" class="p-button-raised" (click)="goAddonBins()">
      <span>Go to Process Bins</span>
    </button>
    <p-checkbox
      inputId="shouldGroupByTransaction"
      [(ngModel)]="shouldGroupByTransaction"
      (ngModelChange)="considerGroupByTrx()"
      [binary]="true"
    ></p-checkbox>
    <label for="shouldGroupByTransaction" class="ml-2">Group By Transaction</label>

    <p-checkbox inputId="shouldShowPodSummaries" [(ngModel)]="shouldShowPodSummaries" [binary]="true"> </p-checkbox>
    <label for="shouldShowPodSummaries" class="ml-2">Show Purchase Order Detail Receipt Summaries</label>
  </div>
</ng-template>
